import type { ReactNode } from 'react';

interface IconComponentProps {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  cssClass?: string;
}

export const IconComponent = (prop: IconComponentProps) => {
  return (
    <img
      src={prop.src}
      alt={prop.alt}
      width={prop.width}
      height={prop.height}
      className={prop.cssClass}
    />
  );
};

export const createIconObject = (src: string, alt: string) => ({
  icon: <IconComponent src={src} alt={alt} />,
  direction: 'top'
});

export const createIconObjectForIcon = (src: ReactNode) => ({
  icon: src,
  direction: 'top'
});
